import { render, staticRenderFns } from "./ChargeBacks.vue?vue&type=template&id=a0df1d2e&"
import script from "./ChargeBacks.vue?vue&type=script&lang=js&"
export * from "./ChargeBacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports